export default __webpack_public_path__ + "static/media/shopifyButton.70b9c652.png";